import React, { useEffect, useState } from "react";
import { InputProps, TextField } from "@mui/material";
import { Base } from "ui/Scripts/source/framework/base";

interface IFormTimeSpanProps {
    value: number;
    maxLength?: number;
    required?: boolean;
    InputProps?: Partial<InputProps>
    onChange: (value: number) => void;
}

export const FormTimeSpan = (props: IFormTimeSpanProps) => {
    const [value, setValue] = useState("");

    useEffect(() => {
        if (!Base.isNullOrUndefined(props.value)) {
            setValue(Base.timeSpanToString(props.value));
        } else {
            setValue("");
        }
    }, [props.value]);

    const handleChange = (event) => {
        const value: string = event.target.value;
        if (!props.maxLength || !value || value.length <= props.maxLength) {
            setValue(event.target.value);
        }
        setValue(value.substring(0, props.maxLength));
    };

    const handleBlur = (event) => {
        const value: string = event.target.value;
        let newValue = value;
        let result: number = null;
        if (props.required || Base.hasNumber(value)) {
            result = value.toTimeSpan();
            newValue = Base.timeSpanToString(result);
        } else {
            newValue = "";
        }
        setValue(newValue);
        props.onChange(result);
    };

    return (
        <TextField
            value={value}
            InputProps={{ ...props.InputProps, inputProps: { maxLength: props.maxLength } }}
            onChange={handleChange}
            onBlur={handleBlur}
        />
    );
};